import React from 'react'
import clsx from 'clsx'
import { withStyles } from '@material-ui/core/styles'
import { Icon } from '@iconify/react'
import styles from './styles'

/** One setup step. Done state comes from data; the number is display only. */
const LaunchStepCard = ({ classes, step, onAction }) => {
  const showLink = !step.done && !step.current

  return (
    <div className={clsx(classes.root, step.done && classes.rootDone)}>
      <div className={classes.header}>
        <span
          className={clsx(
            classes.number,
            step.current && classes.numberCurrent,
            step.done && classes.numberDone,
          )}
          aria-label={step.done ? 'Done' : `Step ${step.number}`}
        >
          {step.done ? (
            <Icon icon="tabler:check" className={classes.checkIcon} />
          ) : (
            step.number
          )}
        </span>
        <span className={classes.duration}>{step.duration}</span>
      </div>

      <div className={clsx(classes.title, step.done && classes.titleDone)}>
        {step.title}
      </div>
      <div className={classes.description}>{step.description}</div>

      {step.current && (
        <button type="button" className={classes.button} onClick={onAction}>
          {step.ctaLabel}
        </button>
      )}
      {showLink && (
        <button type="button" className={classes.link} onClick={onAction}>
          {step.ctaLabel}
          <Icon icon="tabler:arrow-right" className={classes.linkIcon} />
        </button>
      )}
    </div>
  )
}

export default withStyles(styles)(LaunchStepCard)
